export default "__VITE_ASSET__JtEoDnC1__"